// @core/api/endpoints/notifications/get_channel_health.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetChannelHealthResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get channel health status
 * Returns the current health status of a notification channel including recent delivery success rates and any connectivity issues.
 */
export async function GetChannelHealth(
  channel_id: string,
  options?: RequestOptions
): Promise<GetChannelHealthResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/channels/:channel_id/health`;
  requestPath = requestPath.replace(':channel_id', encodeURIComponent(channel_id));
  const requestOptions = options;
  return client.get<GetChannelHealthResponse>(requestPath, { ...requestOptions });
}
